import React, {useState, useEffect} from 'react';
import {Link, withRouter} from "react-router-dom";
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';

// style
import Style from "./style";

// image
import Chevron from "../../Assets/down-chevron.svg";
import SvgIcon from "../../Assets/svg-icon.svg";
import PdfIcon from "../../Assets/pdf-icon.svg";
import Select from "react-select";
import QuestionDrag from '../../Assets/question-drag.svg'
import QuestionDel from '../../Assets/del-question.svg'

// -- redux
import {connect} from "react-redux";
import { AddHelp, EditHelp, DeleteHelp, GetHelpDetails, QuestionDropdownList } from "../../Redux/Actions/HelpAction"
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";


function Help(props) {
    const [base64Icon, setBase64Icon] = useState('');
    const [ImgName, setSvgName] = useState('');
    const [Help, setHelp] = useState('');
    const [OpenModal, setModal] = useState(false);
    const [Title,setTitle] = useState('');
    const [QuestionType, setQuestionType] = useState('');
    const [QuestionTypeID, setQuestionTypeID] = useState('');
    const [AlreadyExists, setAlreadyExists] = useState('');
    const [Type, setType] = useState('');
    const [Information, setInformation] = useState('');
    const [InformationID, setInformationID] = useState('');
    const [InformationError, setInformationError] = useState('');
    const [TypeID, setTypeID] = useState('');
    const [CardsArray, setCardsArray] = useState([]);
    const [SVGError, setSVGError] = useState('');

    useEffect(()=>{
        if (props.location.state && props.location.pathname.split('/')[3] === 'edit-help') {
            props.GetHelpDetails(props.location.state)
        }
        props.QuestionDropdownList()
    },[]);

    useEffect(()=>{
        if (props.details_data && props.details_data.data && props.location.pathname.split('/')[3] === 'edit-help') {
            setHelp(props.details_data.data);
            setTitle(props.details_data.data && props.details_data.data.title);
            setBase64Icon(props.details_data.data && props.details_data.data.icon);
            setTypeID(props.details_data.data && props.details_data.data.type.toString());
            setCardsArray(props.details_data.data && props.details_data.data.questions);
            setInformationID(props.details_data.data && props.details_data.data.information)
            setInformation(props.details_data.data && props.details_data.data.information)
            }
    },[props.details_data]);
    const renderList = () => {
        if(props.question_data && props.question_data.data) {
            return props.question_data.data.map(data =>({label:data.title, value:data.title, id:data.id}))
        }
    };

    const convertSvgToBase64 = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
        const base64String = e.target.result;
            console.log(base64String);
            setBase64Icon(base64String)
        };
        reader.onerror = (error) => {
        console.error("Error reading file:", error);
        };
        reader.readAsDataURL(file);
    };

    const handleChange = (e, type) => {
        e.preventDefault();
            if(e.target.files[0].size  / 1024 < 2000){
                if(e.target.files[0].type === 'image/svg+xml'){
                    e.target.files[0] && setSvgName(e.target.files[0].name);
                    convertSvgToBase64(e.target.files[0]);
                    setSVGError('')
                } else {
                    setSVGError('Only svg is allowed')
                }
            } else{
                setSVGError('File size exceeds')
            }
    };

    const handleModal = (e,type) => {
        e.preventDefault();
        if((type === 'update' || type === 'add') && TypeID === '4'){
            let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
            let regex = new RegExp(expression);
            if (Information.match(regex)) {
                setInformationError('');
                setModal(type);
            } else {
                setInformationError('Invalid URL');
            }
        } else if((type === 'update' || type === 'add') && TypeID === '7'){
            let expression = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
            let regex = new RegExp(expression);
            if (Information.match(regex)) {
                setInformationError('');
                setModal(type);
            } else {
                setInformationError('Invalid email');
            }
        } else{
            setModal(type);
        }
    };

    const CloseModal = (e, type) => {
        e.preventDefault();
        if(type === 'add_yes'){
            if(TypeID !== '5'){
                const data = {
                    title: Title,
                    icon: base64Icon,
                    information: TypeID === '3' ? InformationID : Information,
                    type: TypeID,
                };
                props.AddHelp(data);
                setModal(false);
                props.history.push({
                    pathname: '/dashboard/help',
                    back: 'yes',
                    method: 'add'
                })
            } else {
                let Questions = [];
                CardsArray.map((array) => {
                    Questions.push({
                        id: array.question_id === undefined ? 0 : array.id,
                        question_id: array.question_id === undefined ? QuestionTypeID : array.question_id,
                        order_number: array.order_number,
                        is_mandatory: array.is_mandatory,
                        is_deleted: array.is_deleted === undefined ? 0 : array.is_deleted
                    })
                });
                const data = {
                    title: Title,
                    icon: base64Icon,
                    type: TypeID,
                    information: '',
                    question: Questions
                };
                props.AddHelp(data);
                setModal(false);
                props.history.push({
                    pathname: '/dashboard/help',
                    back: 'yes',
                    method: 'add'
                })
            }
        } else if(type === 'add_no'){
            setModal(false)
        }
        else if(type === 'update_yes'){
            if(TypeID === '5'){
                let Questions = [];
                CardsArray.map((array) => {
                    Questions.push({
                        id: array.question_id === undefined ? 0 : array.id,
                        question_id: array.question_id === undefined ? QuestionTypeID : array.question_id,
                        order_number: array.order_number,
                        is_mandatory: array.is_mandatory,
                        is_deleted: array.is_deleted === undefined ? 0 : array.is_deleted
                    })
                });
                const data = {
                    id: Help.id,
                    title: Title,
                    icon: base64Icon,
                    type: TypeID,
                    information: '',
                    question: Questions,
                };
                props.EditHelp(data);
                setModal(false);
                props.history.push({
                    pathname: '/dashboard/help',
                    back: 'yes',
                    method: 'update'
                })
            } else {
                const data = {
                    id: Help.id,
                    title: Title,
                    icon: base64Icon,
                    information: TypeID === '3' ? InformationID : Information,
                    type: TypeID,
                };
                props.EditHelp(data);
                setModal(false);
                props.history.push({
                    pathname: '/dashboard/help',
                    back: 'yes',
                    method: 'update'
                })
            }
        } else if(type === 'update_no'){
            setModal(false)
        } else if(type === 'delete_yes'){
            props.DeleteHelp(Help.id);
            props.history.push({
                pathname: '/dashboard/help',
                back: 'yes',
                method: 'delete'
            })       
        } else if(type === 'delete_no'){
            setModal(false)
        }
    };

    const handleTypeChange = (selected) => {
        setInformation(selected);
        setInformationID(selected.id);
    };

    const handleCancel = () => {
        props.history.push({
            pathname: '/dashboard/help',
            back: 'yes'
        }) 
    };

    const colourStyles = {
        control: (styles, state) => (
            {
                ...styles,
                backgroundColor: '#3C3C3C',
                border: state.isFocused ? '1px solid #A0A0A0' : '1px solid #3C3C3C',
                transition: 'all 0.25s linear 0s',
                "&:hover": {
                    border: '1px solid #A0A0A0'
                },
                padding: '4px 6px',
                boxShadow: state.isFocused ? null : null,
            }),
            singleValue: (baseStyles, state) => ({
                ...baseStyles,
                color:state.isFocused ? '#ffffff' : '#ffffff',
                backgroundColor: '#3C3C3C'
            }),
    };

    const UserTypeOptions = [
        // { value: 'All', label: 'All', id: '1' },
        { value: 'Personal Banking', label: 'Personal Banking', id: '2' },
        { value: 'Business', label: 'Business', id: '3' },
        { value: 'V1be User', label: 'V1be User', id: '5' },
    ];

    const TypeOptions = [
        { value: 'WebView', label: 'WebView', id: '4' },
        { value: 'Form', label: 'Form', id: '5' },
        { value: 'Mobile', label: 'Mobile', id: '6' },
        { value: 'Email', label: 'Email', id: '7' },
        { value: 'Message', label: 'Message', id: '8' },
    ];

    const ServiceInformationOptions = [
        { value: 'Change Name', label: 'Change Name', id: '11' }
    ];

    const selectType = (selected) => {
        setType(selected.label);
        setTypeID(selected.id);
        setInformationError('');
        setInformation('');
        setInformationID('');
        setQuestionTypeID('')
    };

    
    const selectQuestionType = (selected) => {
        setQuestionType(selected.label);
        setQuestionTypeID(selected.id)
    };

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(CardsArray);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setCardsArray(items);
        passData(items)
    };

    const passData = (items) => {
        let data = [];
        items.map((arr) =>{
            let index = items.findIndex(x => x.id === arr.id);
            let id = items.filter(x => x.question_id === arr.question_id);
            data.push(
                {
                    id: id[0].id,
                    order_number: index + 1,
                    question_id: id[0].question_id,
                    title: id[0].title,
                    is_mandatory: id[0].is_mandatory,
                    is_deleted: id[0].is_deleted
                }
            )
        });
        setCardsArray(data)
    };
    
    const HandleStatus = (id) => {
        const InitialArray = [...CardsArray];
        const targetIndex = CardsArray.findIndex(f => f.question_id === id);
        InitialArray[targetIndex].is_mandatory = InitialArray[targetIndex].is_mandatory === 1 ? 0 : 1;
        setCardsArray(InitialArray);
    };

    const handleAdd = () => {
        if(QuestionTypeID === ''){
            setAlreadyExists('Please select question first.')
        } else{
            const FilteredArray = CardsArray.filter((question) => {
                const postName = question.question_id;
                return postName === QuestionTypeID;
            });
            const deletedArray = CardsArray.filter((question) => {
                const postName = question.is_deleted;
                return postName === 1;
            });
            if (deletedArray.length > 0) {
                const InitialArray = [...CardsArray];
                const targetIndex = deletedArray.filter(f => f.question_id === QuestionTypeID);
                if(targetIndex[0].is_deleted === 1){
                    targetIndex[0].is_deleted = 0
                } else {
                    targetIndex[0].is_deleted = 1
                }
                setCardsArray(InitialArray);
            } else {
                if(FilteredArray.length > 0) {
                    setAlreadyExists('Question already added. Please select another question.')
                } else{
                    setAlreadyExists('');
                    const InitialArray = [...CardsArray];
                    InitialArray.push({
                        title: QuestionType,
                        is_mandatory: 1,
                        question_id: QuestionTypeID,
                        order_number: CardsArray.length + 1,
                        id: 0
                    });
                    setCardsArray(InitialArray);
                }
            }
        }
        setQuestionTypeID('')
    };

    const handleDelete = (question) => {
        setAlreadyExists('');
        if(question.id === 0){
            const InitialArray = [...CardsArray];
            let index = CardsArray.findIndex(function(o){
                return o.question_id === question.question_id;
            });
            if (index !== -1) InitialArray.splice(index, 1);
            setCardsArray(InitialArray);
        } else {
            const InitialArray = [...CardsArray];
            question.is_deleted = 1;
            let index = InitialArray.findIndex(function(o){
                return o.question_id === question.question_id;
            });
            if (index !== -1) CardsArray.splice(index, 1);
            setCardsArray(InitialArray);
        }
    };

    const handleContactNumber = (e) => {
        if(e.target.value.length<13) {
            setInformation(e.target.value)
        } else {
            setInformation(e.target.value.slice(0,12))
        }
    }

    return (
        <>
            {props.loading && <Loader/>}
            <div className='action-wrap'>
                <div className='d-flex justify-content-between align-items-center head-wrap mb-4'>
                    {props.location.pathname.split('/')[2] === 'help' ? <Link to='/dashboard/help' className='d-flex head-left'>
                        <img src={Chevron} alt='Chevron' />
                        <span className='text-nowrap text-white f-20 pl-3 text-uppercase'>{props.location.pathname.split('/')[3] === 'edit-help' ? 'Edit' : 'Add'} Help</span>
                    </Link> : <Link to='/dashboard/settings' className='d-flex head-left'>
                        <img src={Chevron} alt='Chevron' />
                        <span className='text-nowrap text-white f-20 pl-3 text-uppercase'>{props.location.pathname.split('/')[3] === 'edit-help' ? 'Edit' : 'Add'} Help</span>
                    </Link>
                    }
                </div>
                <div className='d-flex justify-content-between flex-wrap'>
                    <div className='w-50 pr-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Icon<span className='text-danger'>*</span></label>
                        <div className='d-flex justify-content-between flex-wrap'>
                            <div className='text-center w-50 pr-4'>
                                <label className="custom-file-upload w-100 position-relative d-flex align-items-center justify-content-center mb-0">
                                    <input className='d-none' type="file" accept="image/svg+xml" onChange={(e) => handleChange(e, 'svg-theme-icon')}/>
                                    <div className='w-100'>
                                        {base64Icon !== '' ? <img src={base64Icon} alt='svg-icon'style={{ width: '30%', height: '30%', objectFit: 'contain' }}/> : <span>Click to browse</span>}
                                        {base64Icon !== '' && <p className='text-white mb-0 mt-1 col-12 ml-auto mr-auto text-truncate'>{ImgName}</p>}
                                        {base64Icon !== '' &&
                                        <div onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setSvgName('');
                                            setBase64Icon('')
                                        }}
                                             className='remove-button'
                                        >
                                            <p className='text-uppercase mb-0 text-white'>Remove</p>
                                        </div>
                                        }
                                    </div>
                                </label>
                                {SVGError && <p className='text-danger f-12 m-0 text-left'>{SVGError}</p>}
                                <span style={{color: '#A0A0A0'}} className='f-12'>Upload SVG</span>
                            </div>
                        </div>
                    </div>
                    <div className='w-50 pl-4'>
                        <div>
                            <label className='text-grey-6 f-16 d-block mb-1'>Title<span className='text-danger'>*</span></label>
                            <input
                                type='text'
                                value={Title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder='Enter Title'
                                className="w-100"
                            />
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-between mt-4'>
                    <div className='pr-4 w-50'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Type<span className='text-danger'>*</span></label>
                        <Select
                            onChange={(selected) => selectType(selected)}
                            options={TypeOptions}
                            styles={colourStyles}
                            placeholder='Select Type'
                            value={TypeOptions.filter(function(option) {
                                return option.id === TypeID;
                            })}
                        />
                    </div>
                </div>
                <div className='d-flex justify-content-between mt-4'>
                    {TypeID === "3" && <div className='w-50 pr-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Key<span className='text-danger'>*</span></label>
                        <Select
                            value={ServiceInformationOptions.filter(function(option) {
                                return option.id === InformationID;
                            }) || ''}
                            onChange={(e) => handleTypeChange(e)}
                            options={ServiceInformationOptions}
                            styles={colourStyles}
                            placeholder= 'Choose Type'
                        />
                    </div>}
                    {TypeID === "4" &&
                        <div className='w-50 pr-4'>
                            <label htmlFor='Key' className='text-grey-6 f-16 d-block mb-1'>Key <span className='text-danger'>*</span></label>
                            <input
                                value={Information}
                                onChange={(e) => setInformation(e.target.value)}
                                type='text'
                                placeholder='Enter url'
                                className="w-100 input-style"
                                id='Key'
                                autoComplete='off'
                            />
                            {InformationError && <p className='f-12 text-danger'>{InformationError}</p>}
                        </div>
                    }
                </div>
                {TypeID === '5' && <div>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Search Question<span className='text-danger'>*</span></label>
                        <div className='d-flex align-items-center'>
                            <Select
                                onChange={(selected) => selectQuestionType(selected)}
                                options={renderList()}
                                styles={colourStyles}
                                placeholder='Search Question'
                                value={renderList() && renderList().filter(function(option) {
                                    return option.id === QuestionTypeID;
                                }) || ''}
                                className='w-100'
                            />
                            <p
                                onClick={() => handleAdd()}
                                className='text-green f-30 cursor-pointer font-weight-bold pl-4 m-0'>+</p>
                        </div>
                        {AlreadyExists && <p className='text-danger f-12'>{AlreadyExists}</p>}
                    </div>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block'>Question - {CardsArray.length - CardsArray.filter(function(item) {return item.is_deleted === 1}).length}</label>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="home_listing" type="listing">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {
                                            CardsArray.length > 0 && CardsArray.map((question, index) => {
                                                return(
                                                    question.is_deleted !== 1 && <Draggable key={index+1} draggableId={(index+1).toString()} index={index}>
                                                        {(provided) => (
                                                            <div className='mt-2' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} key={index}>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='d-flex align-items-center p-3 w-100' style={{background: '#3C3C3C'}}>
                                                                        <img src={QuestionDrag} alt='QuestionDrag'/>
                                                                        <p className='text-white m-0 pl-4'>{question.title}</p>
                                                                    </div>
                                                                    <img
                                                                        onClick={() => handleDelete(question)}
                                                                        src={QuestionDel} className='ml-4 cursor-pointer' alt='QuestionDrag'/>
                                                                    <div className='ml-4'>
                                                                        <p
                                                                            className="text-white label-para f-12 mb-0"
                                                                        >
                                                                            Mandatory
                                                                        </p>
                                                                        <label className="switch mb-0">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={question.is_mandatory === 1}
                                                                                readOnly
                                                                                onClick={() => HandleStatus(question.question_id)}
                                                                            />
                                                                            <span className="slider round"/>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                );
                                            })
                                        }
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>}
                {TypeID === "6" &&
                    <div className='w-50 pr-4'>
                        <label htmlFor='Key' className='text-grey-6 f-16 d-block mb-1'>Key <span className='text-danger'>*</span></label>
                        <input
                            value={Information}
                            onChange={(e) => handleContactNumber(e)}
                            type='number'
                            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                            placeholder='Enter mobile number'
                            className="w-100 input-style"
                            id='Key'
                            autoComplete='off'
                        />
                        {InformationError && <p className='f-12 text-danger'>{InformationError}</p>}
                    </div>
                    }
                    {TypeID === "7" &&
                    <div className='w-50 pr-4'>
                        <label htmlFor='Key' className='text-grey-6 f-16 d-block mb-1'>Key <span className='text-danger'>*</span></label>
                        <input
                            value={Information}
                            onChange={(e) => setInformation(e.target.value)}
                            type='text'
                            placeholder='Enter email'
                            className="w-100 input-style"
                            id='Key'
                            autoComplete='off'
                        />
                        {InformationError && <p className='f-12 text-danger'>{InformationError}</p>}
                    </div>
                    }
                    {TypeID === "8" &&
                    <div className='w-50 pr-4'>
                        <label htmlFor='Key' className='text-grey-6 f-16 d-block mb-1'>Key <span className='text-danger'>*</span></label>
                        <input
                            value={Information}
                            onChange = {(e) => handleContactNumber(e)}
                            type='number'
                            placeholder='Enter message'
                            className="w-100 input-style"
                            id='Key'
                            autoComplete='off'
                        />
                        {InformationError && <p className='f-12 text-danger'>{InformationError}</p>}
                    </div>
                    }               
                <div className='d-flex justify-content-between mt-5'>{
                    props.location.pathname.split('/')[3] === 'edit-help' &&
                    <>
                        <button
                            onClick={(e) => handleModal(e, 'delete')}
                            className='form-button mr-3'>Delete</button>
                        {
                            TypeID === '5' ?
                            <button
                                disabled={!(TypeID && Title && base64Icon && (CardsArray.length - CardsArray.filter(function(item) {return item.is_deleted === 1}).length) > 0)}
                                onClick={(e) => handleModal(e, 'update')}
                                className='form-button ml-3'>Update
                            </button>
                            : <button
                                disabled={!(TypeID && Title && base64Icon && (InformationID || Information))}
                                onClick={(e) => handleModal(e, 'update')}
                                className='form-button ml-3'>Update
                            </button>
                        }
                    </>
                }
                    {
                        props.location.pathname.split('/')[3] === 'add-help' &&
                            <>
                                <button
                                    onClick={(e) => handleCancel(e)}
                                    className='form-button mr-3'
                                >
                                    Cancel
                                </button>
                                {
                                    TypeID === '5' ?
                                            <button
                                                disabled={!(TypeID && Title && base64Icon && (CardsArray.length - CardsArray.filter(function(item) {return item.is_deleted === 1}).length) > 0)}
                                                onClick={(e) => handleModal(e, 'add')}
                                                className='form-button ml-3'>Save
                                            </button>
                                        : <button
                                            disabled={!(TypeID && Title && base64Icon && (InformationID || Information))}
                                            onClick={(e) => handleModal(e, 'add')}
                                            className='form-button ml-3'>Save
                                        </button>
                                }
                            </>
                    }
                </div>
                <Style/>
                {OpenModal && <Modal Name={Title} Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/>}
            </div>
        </>
    );
}

const mapStateToProps = ({HelpReducer}) => {
    const {loading, data, details_data, question_data } = HelpReducer;
    return {loading, data, details_data, question_data }
};

const mapDispatchToProps = {
    AddHelp,
    EditHelp,
    DeleteHelp,
    GetHelpDetails,
    QuestionDropdownList
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Help));